// extracted by mini-css-extract-plugin
module.exports = {"image":"_e7f0c3cb","locationsList":"_ed9dd600","locationItem":"_e3233744","locationLink":"_da4a3a11","additionalTopSpacing":"_ccc50fff"};